define('OutSystems/ReactWidgets/Upload',["require", "exports", "tslib", "OutSystems/ClientRuntime/DataTypes", "OutSystems/ClientRuntime/NativeHelper", "OutSystems/ReactView/HtmlTags", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, DataTypes_1, NativeHelper, HtmlTags_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Upload = void 0;
    var Upload = (function (_super) {
        tslib_1.__extends(Upload, _super);
        function Upload(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.hiddenInputRef = React.createRef();
            _this.state = { value: null };
            return _this;
        }
        Upload_1 = Upload;
        Object.defineProperty(Upload.prototype, "isMandatory", {
            get: function () {
                return this.props.mandatory;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Upload.prototype, "variable", {
            get: function () {
                return this.props.fileContent;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Upload.prototype, "hiddenInput", {
            get: function () {
                return this.hiddenInputRef.current;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Upload.prototype, "inputedValue", {
            get: function () {
                return this.variable;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Upload.prototype, "inputedValueValidity", {
            get: function () {
                return this.hiddenInput.validity;
            },
            enumerable: false,
            configurable: true
        });
        Upload.prototype.getAcceptProperty = function () {
            var type;
            switch (this.props.accept) {
                case 0:
                    type = "image/*";
                    break;
                case 1:
                    type = "video/*";
                    break;
                default:
                    type = "";
            }
            return type;
        };
        Upload.prototype.success = function (data, filename) {
            var contentVar = new DataTypes_1.BinaryData(data);
            if (this.props.fileName) {
                this.props.fileName.value = filename;
            }
            this.variable.value = contentVar;
            this.setState({ value: contentVar });
            if (this.props.onChange) {
                this.props.onChange();
            }
        };
        Upload.prototype.handleFileSelect = function (evt) {
            var _this = this;
            var file = evt.target.files[0];
            if (file) {
                var reader = new FileReader();
                var filename_1 = file.name;
                reader.onload = function (e) {
                    var content = e.target.result;
                    var base64Index = content.indexOf(";base64,");
                    var actualContent = content.substr(base64Index + 8);
                    var contentVar = new DataTypes_1.BinaryData(actualContent);
                    if (_this.props.fileName) {
                        _this.props.fileName.value = filename_1;
                    }
                    _this.variable.value = contentVar;
                    _this.setState({ value: contentVar });
                    if (_this.props.onChange) {
                        _this.props.onChange();
                    }
                };
                reader.readAsDataURL(file);
            }
        };
        Upload.prototype.handleNativeFileSelect = function () {
            var _this = this;
            var w = window;
            if (w.device) {
                if (w.filechooser) {
                    var captureValue = false;
                    if (this.props.extendedProperties && this.props.extendedProperties[Upload_1.Capture]) {
                        captureValue = true;
                    }
                    var options = {
                        accept: this.getAcceptProperty(),
                        capture: captureValue,
                    };
                    w.filechooser.select(options, function (data) {
                        return _this.success(data.FileContent, data.FileName);
                    }, function (err) {
                        throw Error(err);
                    });
                }
                else {
                    throw Error("Filechooser plugin should have loaded by now.");
                }
            }
            else {
                throw Error("Cordova should have loaded by now.");
            }
        };
        Upload.prototype.isNativeAndSpecialVersion = function () {
            var w = window;
            if (w.device) {
                if (NativeHelper.isRunningOnNative()) {
                    if (w.device.platform.toLowerCase() === "android" && w.device.version.indexOf("4.4.2") === 0) {
                        return true;
                    }
                }
            }
            return false;
        };
        Upload.prototype.fileSelectHandlerOnClick = function (evt) {
            var _this = this;
            NativeHelper.ensureNativeReady().then(function () {
                if (_this.isNativeAndSpecialVersion()) {
                    _this.handleNativeFileSelect();
                }
            });
        };
        Upload.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
            if (this.shouldUpdateValue(nextProps.fileContent)) {
                this.updateValue(nextProps.fileContent.value);
            }
        };
        Upload.prototype.updateValue = function (value) {
            this.setState({ value: value });
        };
        Upload.prototype.render = function () {
            var _this = this;
            var type = this.getAcceptProperty();
            var inputStyle = {
                display: "none",
            };
            var inputAttributes = {
                type: "file",
                accept: type,
                style: inputStyle,
                onChange: function (evt) { return _this.handleFileSelect(evt); },
                onClick: function (evt) { return _this.fileSelectHandlerOnClick(evt); },
                ref: this.hiddenInputRef,
                required: this.props.mandatory,
            };
            var extendedProperties = this.props.extendedProperties;
            if (extendedProperties) {
                for (var extendedPropertyName in extendedProperties) {
                    if (this.shouldIncludeOnExtendedProperty(extendedPropertyName)) {
                        inputAttributes[extendedPropertyName] = extendedProperties[extendedPropertyName];
                    }
                }
            }
            var labelAttributes = {
                "data-upload": "",
                className: this.props.style,
            };
            if (this.variable.value.hasContent()) {
                labelAttributes.className += " uploaded";
            }
            this.fillWithBuiltinProperties(labelAttributes);
            var outerSpanAttributes = {
                className: "upload-" + inputAttributes.type,
            };
            var label = React.createElement(HtmlTags_1.HtmlTags.label, labelAttributes, React.createElement(HtmlTags_1.HtmlTags.input, inputAttributes), this.props.children);
            return React.createElement(HtmlTags_1.HtmlTags.span, outerSpanAttributes, label, this.createValidationElement());
        };
        Upload.prototype.shouldIncludeOnExtendedProperty = function (extendedPropertyName) {
            if (extendedPropertyName === "style") {
                return false;
            }
            if (extendedPropertyName === Upload_1.Capture) {
                if (NativeHelper.isRunningOnNative()) {
                    var w = window;
                    if (w.device &&
                        w.device.platform.toLowerCase() === "android" &&
                        /^[7-9](\..*)?$/.test(w.device.version)) {
                        return false;
                    }
                }
            }
            return true;
        };
        var Upload_1;
        Upload.Capture = "capture";
        Upload = Upload_1 = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Upload);
        return Upload;
    }(Widget_1.InputWithVariableWidget));
    exports.Upload = Upload;
});
//# sourceMappingURL=Upload.js.map;
